import React, { useContext } from 'react'
import { BlockLink, Text, Button, Box, Flex } from 'pcln-design-system'
import { Cars, Flights, Hotels } from 'pcln-icons'
import styled from 'styled-components'
import analytics from '@/shared-utils/analytics'
import { ANALYTICS_CATEGORY_HOME } from '@/constants/analytics'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import { RudderProductDesc } from './types'

const NoInventoryWrapper = styled(Flex)`
  flex-direction: row;
  align-items: center;
  ${props => props.theme.mediaQueries[0]} {
    padding-right: 24px;
    padding-left: 24px;
  }
  ${props => props.theme.mediaQueries[1]} {
    width: 66.67%;
  }
  ${props => props.theme.mediaQueries[2]} {
    width: 72.72%;
  }
`

const InventoryTextWrapper = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  width: 100%;
`

type ProductIcon = typeof Flights | typeof Cars | typeof Hotels

const getProductIcon = (product: string): ProductIcon => {
  switch (product) {
    case 'Flights':
      return Flights
    case 'Rental Cars':
      return Cars
    default:
      return Hotels
  }
}

export default function NoInventoryFallback({
  xSellMessaging,
  xSellTarget,
  xSellUrl,
  rudderChildProductCode,
  rudderParentProductCode,
  offerId
}: {
  xSellMessaging: string
  xSellTarget: 'Rental Cars' | 'Hotels' | 'Flights'
  xSellUrl: string
  rudderChildProductCode: RudderProductDesc
  rudderParentProductCode: RudderProductDesc
  offerId: string
}) {
  const { webstats, customer } = useContext(BootstrapDataContext)
  const ProductIcon = getProductIcon(xSellTarget || 'hotel')
  return (
    <>
      <NoInventoryWrapper
        data-label={`Search ${xSellTarget}`}
        data-parent-product={rudderParentProductCode}
        data-child-product={rudderChildProductCode}
        data-source="homepage"
        data-sub-type="cross sell"
        data-has-inventory={false}
        data-cguid={webstats.clientGUID}
        data-email-address={customer.emailAddress}
        data-parent-offer-id={offerId}
        data-rudder-event
        color="background.lightest"
        borderRadius="xl"
        p={3}
        width="100%"
      >
        <ProductIcon color="primary.dark" size="80" mr={40} />
        <InventoryTextWrapper>
          <Box
            color="highlight.light"
            mr="auto"
            px={2}
            py={1}
            borderRadius="lg"
            mb={2}
          >
            <Text color="highlight.shade" fontSize={12} bold>
              SAVE UP TO 40%
            </Text>
          </Box>
          <Text color="text.base" textStyle="heading4" mb={3}>
            {xSellMessaging}
          </Text>
          <BlockLink
            onClick={() => {
              analytics.fireEvent({
                action: 'Feature Box CTA',
                category: ANALYTICS_CATEGORY_HOME,
                label: 'Cross Sell Search Button'
              })
            }}
            href={xSellUrl}
            target="_new"
          >
            <Button data-testid="XSELL_SEARCH_BUTTON">
              Search {xSellTarget}
            </Button>
          </BlockLink>
        </InventoryTextWrapper>
      </NoInventoryWrapper>
    </>
  )
}
